import React from 'react'

import { Badge } from '../Badge'
import avatar from './assets/avatar.png'
import * as S from './styled'

type Props = {
  emoji: string
  text: string
  borderColor?: string
  backgroundColor?: string
  textColor?: string
  iconOnly?: boolean
  verified?: boolean
  withUsername?: boolean
  usernameTextColor?: string
  title?: string
}

export const BadgePreview = ({
  emoji,
  text,
  borderColor,
  backgroundColor,
  textColor,
  verified,
  iconOnly,
  withUsername,
  usernameTextColor,
  title,
}: Props) => (
  <div>
    {title && <S.Title>{title}</S.Title>}
    <S.Container>
      {withUsername && (
        <S.User>
          <S.UserAvatar src={avatar} />
          <S.Username style={{ color: usernameTextColor }}>Username</S.Username>
        </S.User>
      )}
      <Badge
        emoji={emoji}
        text={text}
        borderColor={borderColor}
        backgroundColor={backgroundColor}
        textColor={textColor}
        verified={verified}
        iconOnly={iconOnly}
      />
    </S.Container>
  </div>
)
